exports.experience = [
    {
        type: "exp",
        title: "Frontend Developer | Full-time",
        date: "Spokn | May 2021 - present",
    },
    {
        type: "exp",
        title: "Frontend Development | Internship",
        date: "ESB | Aug 2020 - Oct 2020",
    },
    {
        type: "exp",
        title: "Junior Teaching Assistant | Volunteer",
        date: "GUC | Feb 2019 - May 2020"
    },
]

exports.education = [
    {
        type: "edu",
        title: "Bachelor of Computer Science & Engineering",
        info: "German University in Cairo | Egypt",
        date: "Sep 2017 - May 2022",
    },
    {
        type: "edu",
        title: "Front-End Web Developer Nanodegree",
        info: "Udacity | Virtual",
        date: "Jun 2020 – Sep 2020",
    },
    {
        type: "edu",
        title: "Semester Abroad",
        info: "German International University | Germany",
        date: "Sep 2019 - Jan 2020",
    },
    {
        type: "edu",
        title: "IGCSE",
        info: "Homeschooled | Saudi Arabia",
        date: "May 2015 - Jul 2017",
    }
]

exports.projects = [
    {
        img: "project11",
        title: "Sawaed",
        type: "Web",
        description: "Designed and implemented the formal website for Sawaed, one of the top MEP Contractors in KSA and an integrated construction company.",
    },
    {
        img: "project10",
        title: "Medducation",
        type: "Web",
        description: "Designed and implemented a blog for a medical student.",
        link: "https://medducation.herokuapp.com/",
        button: "Visit",
    },
    {
        img: "project8",
        title: "GUC Tas' Portal",
        type: "Web",
        description: "Implemented a GUC portal that provides GUC staff members with multiple useful functionalities.",
        link: "https://guc-cms.ahmedashraf.me/login",
        button: "Visit",
    },
    {
        img: "project9",
        title: "EBS-lab website",
        type: "Web",
        description: "Designed and implemented the formal website for EBS-lab.",
        link: "https://www.ebs-lab.com/",
        button: "Visit",
    }, {
        img: "project7",
        title: "ERP-System",
        type: "Web",
        description: "Contributed in designing and implementing an ERP system during my internship.",
    }, {
        img: "project0",
        title: "Personal Portfolio",
        type: "Web",
        description: "Created my personal portfolio using React js to preview my skills, experience and projects.",
        link: "https://github.com/sarah23s/My-website/",
    },
    {
        img: "project1",
        title: "Keep my notes",
        type: "Web",
        description: "Web app built with React used to keep notes with titles.",
        link: "https://github.com/sarah23s/Keep-my-Notes",
        button: "source code",
    },
    {
        img: "project2",
        title: "Foreigner:",
        type: "Web",
        description: "A travel app that obtains a desired trip location and date from the user, and displays weather and an image of the location using information obtained from external APIs.",
        link: "https://github.com/sarah23s/Travel-App",
        button: "source code",
    },
    {
        img: "project3",
        title: "Article Evaluator:",
        type: "Web",
        description: "Building a web tool that allows users to run Natural Language Processing (NLP) on articles or blogs found on other websites.",
        link: "https://github.com/sarah23s/Evaluate-Articles-with-NPL",
        button: "source code",
    },
    // {
    //     img: "project5",
    //     title: "Simon Game",
    //     type: "Web",
    //     description: "A simple game designed with js where the user needs to memorise the patter of colors targeted adding a new one at each level.",
    //     link: "https://github.com/sarah23s/Simon-Game",
    //     button: "source code",
    // },
    // {
    //     img: "project4",
    //     title: "Weather App",
    //     type: "Web",
    //     description: "Creating an asynchronous web app that uses Web API and user data to dynamically update the UI.",
    //     link: "https://github.com/sarah23s/Weather-Journal-App",
    //     button: "source code",
    // },
    {
        img: "project6",
        title: "BMI calculator",
        type: "Mobile",
        description: "A Flutter App where the user adjusts the weight and height and chooses the gender then the bmi is calculated.",
        link: "https://github.com/sarah23s/BMI-calculator/tree/master",
        button: "source code",
    }
]

exports.extracurricularActivities = [
    {
        img: "github-workshop",
        title: "Github workshop",
        date: "Feb 2022",
        job: "Host",
        text:
            "A session for undergraduate students at the GUC about git and version control."
    },
    {
        img: "Web head",
        title: "Web Development, IEEE",
        date: "2021-2022",
        job: "Head",
        text:
            "Leading the committee of Web development that aimed at providing an introduction" +
            "to modern web application development and an introduction to MERN stack."
    },{
        img: "hackathon",
        title: "Hackathon",
        date: "Dec 2020",
        job: "1st place winner",
        text:
            "Achieved the 1st position in the 'Com-H: Computing for combating harassment' Hackathon that was organized by the German University in Cairo and University Duisburg Essen."
    },
    {
        img: "empowerKids1",
        title: "Empower Kids, Bdaya",
        date: "2020",
        job: "Head",
        text:
            "Leading the committee of Empower kids where we spread the entrepreneurial" +
            "way of thinking and business idea implementation among orphans juniors."
    },
    {
        img: "RandD",
        title: "Research and Development, IEEE",
        date: "2020",
        job: "Member",
        text:
            "Sessions where members discuss and present a viral topic." +
            "It aims for improving presentation and communication skills along with gaining general knowledge."
    },
    {
        img: "IandD",
        title: "I&D, Bdaya",
        date: "2017-2019",
        job: "Member",
        text:
            "Interaction and Devalopment committee. Ensuring Bdaya members’ continuous " +
            "motivation, development, and innovation. As to provide means to " +
            "maintain a minimum standard of quality."
    },
    {
        img: "insider",
        title: "News and Reporting, Insider",
        date: "2019",
        job: "Member",
        text:
            "Insider is a global news and lifestyle publication.Our job role was is to inform and inspire GUCians with news and stories they want and need to know."
    },
    {
        img: "closingEvent",
        title: "Closing Event, Bdaya",
        date: "2019",
        job: "Project Manager",
        text: "Organizing the last event of Bdaya at the end of the year."
    },
    {
        img: "tiq",
        title: "The Intelligent Question",
        date: "2019",
        job: "Member",
        text:
            "TIQ is a debate club, where we strive to produce dialogue in it's most exciting" +
            "form, up on stage, going head to head with other people. For aquiring effective" +
            "communication skills and perpetually seeking knowledge."
    },
    {
        img: "hr",
        title: "HR, Ihlam Club",
        date: "2019",
        job: "Member",
        text:
            "Responsible for planning, directing and coordinating the administrative functions of Ihlam."
    },
    {
        img: "lawenha",
        title: "Lawenha, Ihlam Club",
        date: "2019",
        job: "Organizer",
        text:
            "Lawenha event is an event that aims for improving building designs and colors, where we go for old buildings and paint them."
    },
    {
        img: "carnivalElSaff",
        title: "Carnival El Saff, Bdaya",
        date: "2018",
        job: "Organizer",
        text:
            "Organizing an outdoor event featuring games, music, food, and other forms of entertainment for poor children."
    },
    {
        img: "Olimpikyat",
        title: "Olimpikyat'8, Bdaya",
        date: "2018",
        job: "Organizer",
        text:
            "Organizing a sports event for GUC students including games and competitions."
    }
]

exports.certificates = [
    {
        title: "Several courses (30 hrs)",
        date: "Frontend Masters | Aug 2021 - Oct 2021",
        type: "Web Development",
        courseLink: 'https://frontendmasters.com/courses',
    },
    {
        title: "The Complete 2020 Web Development Bootcamp",
        date: "Angela Yu on Udemy | Aug 2020",
        link: "cert1",
        type: "Web Development",
        courseLink: 'https://www.udemy.com/course/the-complete-web-development-bootcamp/',
    },
    {
        title: "The Complete Android Oreo Developer Course ",
        date: "Udemy | March 2020",
        link: "cert2",
        type: "Mobile Development",
        courseLink: 'https://www.udemy.com/course/the-complete-android-oreo-developer-course/',
    },
    {
        title: "The Complete 2020 Flutter Development Bootcamp with Dart",
        date: "Udemy | Feb 2020",
        link: "cert3",
        type: "Mobile Development",
        courseLink: 'https://www.udemy.com/course/flutter-bootcamp-with-dart/',
    },
    {
        title: "Data structures and algorithm (online specialization)",
        date: "University of California San Diego | present",
        type: "Algorithms",
        courseLink: 'https://www.coursera.org/specializations/data-structures-algorithms',
    },
    {
        title: "ACM sessions",
        date: "GUC | 2018-2019",
        type: "Algorithms",
    },
    {
        title: "Problem-solving Programming 2: (coach Mohammed Abdelwahab)",
        date: "Coach Academy | Feb 2017",
        link: "cert7",
        type: "Algorithms",
        courseLink: 'https://coachacademy.club/programming-in-c',
    },
    {
        title: "Problem-solving Programming 1: (coach Mohammed Abdelwahab)",
        date: "Coach Academy | Aug 2016",
        link: "cert6",
        type: "Algorithms",
        courseLink: 'https://coachacademy.club/cpinew',
    },
    {
        title: "Cryptography I",
        date: "by Stanford University | Dec 2019",
        link: "cert4",
        type: "Security",
        courseLink: 'https://www.coursera.org/learn/crypto',
    },
    {
        title: "Learning SQL Programming",
        date: "Linkedin | Jul 2020",
        link: "cert8",
        type: "Programming",
        courseLink: 'https://www.linkedin.com/learning/learning-sql-programming-8382385/learning-sql-programming',
    },
    {
        title: "Java Certifications level 2",
        date: "CCA | Jul 2019",
        link: "cert50",
    },
    {
        title: "Java Certifications level 1",
        date: "CCA | Jul 2019",
        link: "cert51",
        type: "Programming",
    },
    {
        title: "Introduction to JavaScript",
        date: "Robin Haney on Udemy | July 2019",
        link: "cert5",
        type: "Programming",
        courseLink: 'https://www.udemy.com/course/the_complete_javascript_course_for_beginners/',
    },
    {
        title: "Social Psychology",
        date: "Wesleyan University on Coursera | present",
        // link: "cert10", 
        type: "Others",
        courseLink: 'https://www.coursera.org/learn/social-psychology',
    },
    {
        title: "Basic Psychology",
        date: "Dr. Asif Kamal on Udemy | July 2019",
        link: "cert10",
        type: "Others",
        courseLink: 'https://www.udemy.com/course/basic-psychology-course/',
    },
    {
        title: "Personality Psychology",
        date: "Glory Dimitrova on Udemy | July 2019",
        link: "cert9",
        type: "Others",
        courseLink: 'https://www.udemy.com/course/personality-psychology-certification-course/',
    }
]